import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { apiRequest } from '../../apiService/allApi';
import "../css/base.css"; // Ensure you create this CSS file
import { RiCustomerService2Line, RiFlashlightLine, RiLock2Line, RiShieldCheckLine, RiShieldKeyholeLine, RiShieldUserLine } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import OtpInput from "react-otp-input";


export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [showSplash, setShowSplash] = useState(true);
  const referral = referralcode || location.pathname.split("/")[2] || "";


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  const handleClick = async (e) => {
    if (e) e.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return Swal.fire({ icon: "error", title: "Oops...", text: "Please enter correct phone number" });
    }
    setIsloading1(true);
    const respone = await apiRequest('login', "POST", { Phone, referral });
    setIsloading1(false);
    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);
      if (respone?.data?.myToken) {
        Swal.fire({ icon: "success", title: "OTP", text: "Demo OTP: " + respone?.data?.myToken });
      }
    } else {
      Swal.fire({ icon: "error", title: "Oops...", text: respone?.data?.msg || "Login failed" });
    }
  };

  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest(`login/finish`, "POST", { Phone, twofactor_code, referral, secretCode });
      setIsloading1(false);
      if (response?.data?.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({ icon: "error", title: "Oops...", text: response?.data?.msg || "Something went wrong!" });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({ icon: "error", title: "Oops...", text: "Error verifying OTP" });
    }
  };
  if (showSplash) {
    return (
      <div className="rk_splash_screen">

        {/* ================= BACKGROUND ================= */}

        <div className="rk_splash_glow rk_splash_glow_1"></div>
        <div className="rk_splash_glow rk_splash_glow_2"></div>
        <div className="rk_splash_glow rk_splash_glow_3"></div>

        {/* Animated Background Lines */}
        <div className="rk_splash_lines">
          <span className="rk_splash_line rk_splash_line_1"></span>
          <span className="rk_splash_line rk_splash_line_2"></span>
          <span className="rk_splash_line rk_splash_line_3"></span>
        </div>

        {/* Background Dots */}
        {/* <div className="rk_splash_dot_grid rk_splash_grid_1"></div>
        <div className="rk_splash_dot_grid rk_splash_grid_2"></div> */}

        {/* Floating Particles */}
        <div className="rk_splash_particles">

          {Array.from({ length: 20 }).map((_, index) => (
            <span key={index}></span>
          ))}

        </div>


        {/* ================= CONTENT ================= */}

        <div className="rk_splash_content">

          {/* Logo */}
          <div className="rk_splash_logo_wrap">

            <div className="rk_logo_ring rk_ring_1"></div>
            <div className="rk_logo_ring rk_ring_2"></div>

            <img
              src="./images/prince-ludo.png"
              alt="Prince Ludo"
              className="rk_splash_logo"
            />

          </div>


          {/* Tagline */}
          <h3 className="rk_splash_tagline">
            <span>✦</span>
            PLAY. WIN. RULE THE GAME.
            <span>✦</span>
          </h3>

          {/* Divider */}
          <div className="rk_gold_divider">
            <i></i>
            <span>✦</span>
            <i></i>
          </div>


          {/* ================= LOADER ================= */}

          <div className="rk_loader_wrap">

            {/* Left Dice */}
            <div className="rk_loader_dice rk_dice_left">
              🎲
            </div>


            {/* Progress */}
            <div className="rk_progress_area">

              <div className="rk_progress_bar">

                <div className="rk_progress_fill">
                  <span></span>
                </div>

              </div>

              <div className="rk_progress_shine"></div>

            </div>


            {/* Right Dice */}
            <div className="rk_loader_dice rk_dice_right">
              🎲
            </div>

          </div>


          {/* Percentage */}
          <div className="rk_loading_percent">
            <span className="rk_percent_value">Loading</span>
            <span className="rk_percent_dots">...</span>
          </div>


          {/* Slider Dots */}
          <div className="rk_slider_dots">

            <span></span>

            <span className="active"></span>

            <span></span>

          </div>


          {/* Loading Text */}
          <h4 className="rk_loading_text">
            Shuffling the board...
          </h4>


          {/* Bottom Divider */}
          <div className="rk_gold_divider rk_bottom_divider">
            <i></i>
            <span>✦</span>
            <i></i>
          </div>

        </div>

      </div>
    );
  }
  return (
    <div className="rk_login_screen">

      {/* ================= BACKGROUND ================= */}

      <div className="rk_bg_glow rk_glow_one"></div>
      <div className="rk_bg_glow rk_glow_two"></div>
      <div className="rk_bg_glow rk_glow_three"></div>

      {/* Animated Lines */}
      <div className="rk_animated_lines">
        <span className="rk_line rk_line_1"></span>
        <span className="rk_line rk_line_2"></span>
        <span className="rk_line rk_line_3"></span>
        <span className="rk_line rk_line_4"></span>
      </div>

      {/* Animated Dots */}
      <div className="rk_dots rk_dots_1"></div>
      <div className="rk_dots rk_dots_2"></div>
      <div className="rk_dots rk_dots_3"></div>

      {/* Floating particles */}
      <div className="rk_particles">
        {Array.from({ length: 18 }).map((_, index) => (
          <span key={index}></span>
        ))}
      </div>


      {/* ================= BRAND ================= */}

      <div className="rk_login_brand">

        <div className="rk_logo_area">
          <img
            src="./images/prince-ludo.png"
            alt="RK Ludo"
            className="rk_login_logo"
          />
        </div>

      </div>


      {/* ================= LOGIN ================= */}

      <div className="rk_login_content">

        <div className="rk_login_card">

          <div className="rk_card_glow"></div>

          {/* Header */}
          <div className="rk_login_header">

            <div className="rk_login_icon">
              <RiShieldUserLine />
            </div>

            <div className="rk_login_heading">
              <h2>
                WELCOME <span>BACK!</span>
              </h2>

              <p>
                Register / Login to Prince Ludo
              </p>
            </div>

          </div>


          {/* Form */}
          <div className="rk_login_inner">

            <form onSubmit={otp ? varifyOtp : handleClick}>

              {/* ================= PHONE ================= */}

              <div className="rk_phone_box">

                <div className="rk_country">

                  <img
                    src="https://flagcdn.com/w40/in.png"
                    alt="India"
                    className="rk_flag"
                  />

                  <span>+91</span>


                </div>

                <div className="rk_phone_divider"></div>

                <input
                  type="tel"
                  placeholder="Enter mobile number"
                  value={Phone}
                  disabled={otp}
                  onChange={(e) =>
                    setPhone(
                      e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10)
                    )
                  }
                  required
                />

              </div>


              {/* ================= OTP ================= */}

              {otp && (
                <div className="rk_otp_overlay">

                  <div className="rk_otp_card">

                    <button
                      type="button"
                      className="rk_otp_close"
                      onClick={() => setOtp(false)}
                    >
                      ×
                    </button>

                    <div className="rk_otp_icon">
                      <RiShieldKeyholeLine />
                    </div>

                    <div className="rk_otp_title">
                      VERIFY OTP
                    </div>

                    <p className="rk_otp_description">
                      Enter the 6-digit verification code sent to
                    </p>

                    <div className="rk_otp_phone">
                      +91 {Phone}
                      <span>✓</span>
                    </div>

                    <div className="rk_otp_inputs">

                      <OtpInput
                        value={twofactor_code}
                        onChange={settwofactor_code}
                        numInputs={6}
                        renderInput={(props) => (
                          <input
                            {...props}
                            className="rk_otp_digit"
                            type="text"
                            inputMode="numeric"
                          />
                        )}
                      />

                    </div>

                    <div className="rk_resend">

                      {seconds > 0 ? (
                        <>
                          Resend code in{" "}
                          <strong>{seconds}s</strong>
                        </>
                      ) : (
                        <span
                          className="rk_resend_link"
                          onClick={handleClick}
                        >
                          Resend OTP
                        </span>
                      )}

                    </div>

                    <button
                      type="button"
                      className="rk_verify_btn"
                      onClick={varifyOtp}
                    >
                      <span>VERIFY & LOGIN</span>
                      <span className="rk_btn_arrow">
                        →
                      </span>
                    </button>

                  </div>

                </div>
              )}


              {/* ================= CONTINUE ================= */}

              <button
                type="submit"
                className="rk_continue_btn"
                disabled={isLoading1}
              >

                {isLoading1 ? (
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                ) : otp ? (
                  <>
                    VERIFY OTP
                    <span>→</span>
                  </>
                ) : (
                  <>
                    CONTINUE
                    <span>→</span>
                  </>
                )}

              </button>


              {/* ================= OR ================= */}

              <div className="rk_or">

                <div></div>

                <span>OR</span>

                <div></div>

              </div>


              {/* ================= FACEBOOK ================= */}

              {/* <button
                type="button"
                className="rk_facebook_btn"
              >

                <BsFacebook />

                <span>
                  Continue with Facebook
                </span>

              </button> */}


              {/* ================= GUEST ================= */}

              {/* <div className="rk_guest">

                <span>
                  Don't want to login?
                </span>

                <button type="button">
                  Play as a Guest
                  <span>→</span>
                </button>

              </div> */}


              {/* ================= FEATURES ================= */}

              <div className="rk_features">

                {/* Secure */}
                <div className="rk_feature">

                  <div className="rk_feature_icon rk_secure_icon">
                    <RiShieldCheckLine />
                  </div>

                  <div className="rk_feature_text">
                    <strong>Secure</strong>
                    <span>& Safe</span>
                  </div>

                </div>


                <div className="rk_feature_separator"></div>


                {/* Withdrawal */}
                <div className="rk_feature">

                  <div className="rk_feature_icon rk_withdraw_icon">
                    <RiFlashlightLine />
                  </div>

                  <div className="rk_feature_text">
                    <strong>Instant</strong>
                    <span>Withdrawals</span>
                  </div>

                </div>


                <div className="rk_feature_separator"></div>


                {/* Support */}
                <div className="rk_feature">

                  <div className="rk_feature_icon rk_support_icon">
                    <RiCustomerService2Line />
                  </div>

                  <div className="rk_feature_text">
                    <strong>24/7</strong>
                    <span>Support</span>
                  </div>

                </div>

              </div>


              {/* ================= TERMS ================= */}

              <div className="rk_terms">

                <div className="rk_terms_icon">
                  <RiLock2Line />
                </div>

                <div>
                  By continuing, you agree to our{" "}
                  <span>
                    Terms & Conditions
                  </span>
                </div>

              </div>

            </form>

          </div>

        </div>

      </div>

    </div>
  );
}